import { TooltipContent } from '@anm/components/Tooltip';
import IconButton from '@anm/components/buttons/IconButton';
import styled from 'styled-components';

export const Wrapper = styled.div`
  ${TooltipContent} {
    top: 60px;
    font-size: 14px;
    min-width: 300px;
  }
`;

export const AddToBrandButton = styled(IconButton)`
  padding: 0 11px;
  min-width: 175px;
  line-height: 19px;
  font-weight: bold;

  &:before {
    margin-right: 10px;
    flex-shrink: 0;
  }
`;
